<!-- <span>{{ currVal | json }}</span> -->
<div class="invalid-feedback d-block" *ngIf="errors && errors.length">
    <span *ngFor="let msg of errors" class="d-block">{{
        msg | translate
    }}</span>
</div>
